/**
 *  30/03/2022 v 1.0 - JuanMa
 */

 import React from 'react'
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import PropTypes from 'prop-types';
import * as Classes from "@blueprintjs/core/lib/esm/common/classes";
import {Button, Dialog, FormGroup, InputGroup, Intent, Spinner, Tooltip} from "@blueprintjs/core";
import GridRDG from "../../adazzle/GridRDG";
import "../../resources/css/selectorlista.css";
import ClienteRestful from "../network/ClienteRestful";
import {
    CELLTIPO_CADENA,
    CELLTIPO_ICONOACCION_DESCARGAR,
    CELLTIPO_IMAGENLISTA
} from "./TiposCeldas";



class SelectorDocumentos extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            opened: props.opened ? props.opeed : false,
            titulo: props.titulo,
            documentos:[],
            documento: props.valor ? props.valor : "",
            icon: props.icon,
            cargandoDatos: false,
            proyectoCodigoId: "12031M2", //props.proyectoCodigoId,
            ordenCodigoId: props.ordenCodigoId,
        }
        this.editProyecto= React.createRef();
        this.editOrden= React.createRef();
        this.btRefrescar= React.createRef();
        this.edit= React.createRef();
    }

    loadDocumentos = () => {
        const {urlServicioDocumentos} = this.props;
        const {proyectoCodigoId, ordenCodigoId} = this.state;

        let url= urlServicioDocumentos + "listcodigoid/";
        if (proyectoCodigoId)
            url += "Proyecto/" + proyectoCodigoId;
        else{
            if (ordenCodigoId)
                url += "Ordenfabricacion/" + ordenCodigoId;
        }
        console.log("++++ LOAD DOCUMENTOS:");
        console.log(url);
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doPost( {}, response => {
            if (clienteRestful.exito && response){
                console.log("documentos: ", response);
                this.setState({cargandoDatos: false, documentos: response}, () => {

                });

            }
        });
    }

    
    onSelectedRow= (documentoSeleccionado) => {
        const{onSeleccionRowAceptar} = this.props;
        console.log("Selector Lista");
        console.log("documento: ", documentoSeleccionado);
        this.setState({documento: documentoSeleccionado.nombre});
    }

    onAcceptedRow= (documentoAccepted) => {
        console.log("onACCEPTEDROW");
        if (documentoAccepted)
            this.setState({documento: documentoAccepted.nombre}, ()=> { this.onAceptar()});
        else
            this.onAceptar();
    }

    onCancelar= () => {
        const {tabOrderManager, campoNombre} = this.props;
        if (tabOrderManager)
            tabOrderManager.setFocusSiguiente(campoNombre);  //!!! Importante primero el setFocus y luego el setState.
        this.setState({ opened: false});
    }

    onAceptar= () => {
        const {documento} =  this.state;
        const {tabOrderManager, onDocumentoAceptado} = this.props;

        console.log("onAceptar: ", documento);

        //if (tabOrderManager)
        //    tabOrderManager.setFocusSiguiente(campoNombre);  //!!! Importante primero el setFocus y luego el setState.

        //this.setState({ opened: false, documento: null, proyectoCodigoId: null, ordenCodigoId: null}); //Todo preparado para la siguiente busqueda
        this.setState({ opened: false, proyectoCodigoId: null, ordenCodigoId: null}); //Todo preparado para la siguiente busqueda
        onDocumentoAceptado && onDocumentoAceptado(documento);
    }

    onEliminar= () => {
        const {OnDocumentoChanged} = this.props;
        this.setState({valor: ""});
        OnDocumentoChanged && OnDocumentoChanged(null);
    }


    keyPress= (target) =>{
        const {tabOrderManager, campoNombre} = this.props;
        if(target.charCode===13){
            tabOrderManager.setFocusSiguiente(campoNombre);
        }
    }

    keyUp= (event) =>{
        const {onMostrar} = this.props;
        //console.log(event.keyCode);
        //if (event.keyCode === 16){ //MAYUS
        if (event.keyCode === 17){  //CTRL
            onMostrar && onMostrar();
            this.setState({opened: true})
        }
    }

    keyPressProyecto= (target) =>{
        if(target.charCode===13){
            this.editOrden.current.focus();
        }
    }

    keyPressOrden= (target) =>{
        if(target.charCode===13){
            this.loadDocumentos();
        }
    }


    renderEdit=(renderConFormGroupReal) => {
        const {opened, titulo, documento} =  this.state;
        const {onMostrar,  obligatorio, width, readonly} = this.props;

        const inputGroupId= "igDocumento";
        let readonlyReal= readonly && Boolean(readonly);
        let tituloReal= obligatorio ?  titulo + "*" : titulo;
        let widthReal= width ? width.toString() + "px" : "300px";
        return (
            <div className="selectorlista">
                {!renderConFormGroupReal && <div className="selectorListaTitulo">{tituloReal}</div>}
                <InputGroup
                    disabled={readonlyReal}
                    style={{width: widthReal}}
                    id={inputGroupId}
                    autoComplete="off"
                    leftIcon={"document"}
                    placeholder={titulo}
                    value={documento ? documento : ""}
                    onClick={() => {
                        onMostrar && onMostrar();
                        this.setState({opened: true})
                    }}
                    onKeyPress={this.keyPress}
                    onKeyUp={this.keyUp}
                    inputRef={this.edit }
                    //inputRef={campoNombre && tabOrderManager ? tabOrderManager.getRef(campoNombre) : null}
                    onChange={() => {
                    }} //Lo ponemos vacío porque tenemos que poner un onChange para que no salte el warning y no queremos que se pueda escribir.
                />
                {!readonlyReal &&
                <Button style={{marginLeft: 10}} icon="trash" className="selectorListaBoton" onClick={this.onEliminar}/>
                }

            </div>
        )
    }

    renderDialogoLista=() => {
        const {opened, documentos, cargandoDatos, proyectoCodigoId, ordenCodigoId} =  this.state;
        const {ocultarEncabezados, clickRowEsAceptar} = this.props;

        let columnas = [
            {campo:"tipo", titulo: "Tipo", tipo: CELLTIPO_IMAGENLISTA, ancho:50,
                imagenes: [
                    {valor:'png', imagen:'png2.png'},
                    {valor:'jpg', imagen:'jpg2.png'},
                    {valor:'pdf', imagen:'pdf2.png'},
                    {valor:'ods', imagen:'xls2.png'}]},
            {campo:"nombre", titulo: "Nombre", tipo: CELLTIPO_CADENA, ancho:300},
            {campo:"fecha", titulo: "Fecha", tipo: CELLTIPO_CADENA, ancho:140},
            {campo:"tamagno", titulo: "Tamaño", tipo: CELLTIPO_CADENA, ancho:100},
            //{campo:"descargar", tipo: CELLTIPO_ICONOACCION_DESCARGAR, ancho: 50, onAccion: this.descargarDocumento},
        ];

        let height= 350;
        let gridHeight= 320;

        return (
            <Dialog
                icon="info-sign"
                onClose={this.onCancelar}
                title= {"Selección"}
                isOpen={opened}
                usePortal= {true}
                canOutsideClickClose={false}
                autofocus={true}
                style={{width: "700px"}}
                onOpened={() => {
                    console.log("ON OPENED");
                    console.log(this.editProyecto);
                    if (this.editProyecto && this.editProyecto.current)
                        this.editProyecto.current.focus();
                }}
            >
                <div className={Classes.DIALOG_BODY} style={{height:height}}>
                    <div className="selectorlista_encabezado">
                        <FormGroup style={{width:200}} key={"fgProyecto"} label= {"Proyecto"} labelFor={"igProyecto"} inline={true}>
                            <InputGroup
                                id= {"igProyecto"}
                                placeholder= {"Proyecto"}
                                value={proyectoCodigoId ? proyectoCodigoId : ""}
                                onChange={ (event) => {this.setState({proyectoCodigoId: event.target.value})} }
                                inputRef={this.editProyecto}
                                onKeyPress={this.keyPressProyecto}
                            />
                        </FormGroup>
                        <FormGroup style={{width:200, marginLeft: 10}}  key={"fgOrden"} label= {"Orden"} labelFor={"igOrden"} inline={true}>
                            <InputGroup
                                id= {"igOrden"}
                                placeholder= {"Orden de trabajo"}
                                value={ordenCodigoId ? ordenCodigoId : ""}
                                onChange={ (event) => {this.setState({ordenCodigoId: event.target.value})} }
                                inputRef={this.editOrden}
                                onKeyPress={this.keyPressOrden}
                            />
                        </FormGroup>
                        <Button style={{marginLeft: 10}} icon="refresh" text={"Refrescar"} onClick={this.loadDocumentos} />
                    </div>

                    { cargandoDatos && <Spinner intent={Intent.PRIMARY} size={50} /> }


                    { !cargandoDatos &&
                    <GridRDG estilo={{height: gridHeight}}
                             columnas={columnas} datos={documentos}
                             onSelectedRow={this.onSelectedRow}
                             ordenable={true}
                             mostrarChecksSeleccion={false}
                             rowKey={"codigo"}
                             mostrarHeaderRow={!ocultarEncabezados}
                             onRowSelectedReturn={ this.onAcceptedRow}
                             rowClickedIsReturn={clickRowEsAceptar}
                             showBuscador={false}
                    />
                    }
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Tooltip content="Aceptar">
                            <Button style={{marginTop: 10}} intent={Intent.SUCCESS} icon="tick-circle" onClick={this.onAceptar}>Aceptar</Button>
                        </Tooltip>
                        <Tooltip content="Cancelar">
                            <Button style={{marginTop: 10}} intent={Intent.DANGER} icon="delete" onClick={this.onCancelar}>Cancelar</Button>
                        </Tooltip>
                    </div>
                </div>
            </Dialog>
        )
    }

    render() {
        const {titulo, documento} =  this.state;
        const {obligatorio, renderConFormGroup} = this.props;
        const inputGroupId= "igDocumento";
        let renderConFormGroupReal= renderConFormGroup ? renderConFormGroup : true;

        //console.log("renderconFormGroup: ", renderConFormGroupReal);
        console.log("Render:");
        console.log("documento: ", documento);

        return (
            <div >
                {!Boolean(renderConFormGroupReal) && this.renderEdit(renderConFormGroupReal)}
                {Boolean(renderConFormGroupReal) &&
                <FormGroup
                    label={titulo}
                    labelFor={inputGroupId}  labelInfo={obligatorio ? "*" : ""}>
                    {this.renderEdit(renderConFormGroupReal)}
                </FormGroup>
                }
                {this.renderDialogoLista()}
            </div>
        );
    }
}


SelectorDocumentos.propTypes = {
    urlServicioDocumentos: PropTypes.string,
    proyectoCodigoId: PropTypes.string,
    ordenCodigoId: PropTypes.string,

    onMostrar: PropTypes.func,
    tabOrderManager: PropTypes.object,
    obligatorio: PropTypes.bool,
    onDocumentoAceptado: PropTypes.func,

    inline: PropTypes.bool,
    ocultarEncabezados: PropTypes.bool,
    width: PropTypes.number,
    readonly: PropTypes.bool,
    renderConFormGroup: PropTypes.bool,


}

export default SelectorDocumentos

